import React from 'react';
import { useSearchPicker, SearchPicker } from '@wegroup/design-system';
import { FormOption } from '../../../../../types/Form';

export interface Option {
  label: string;
  value: string;
  icon?: React.FC<React.PropsWithChildren<{ color: string }>>;
}

interface Props {
  options: FormOption[];
  isOpen: boolean;
  selected: string[];
  onClose: (options: Option[]) => void;
  isDisabled?: boolean;
}

const MultiSelectInputSearchPicker: React.FC<
  React.PropsWithChildren<Props>
> = ({ options, isOpen, selected, onClose, isDisabled }) => {
  const { componentProps } = useSearchPicker({
    searchFunction: (val) =>
      options.filter((o) => o.label.toLowerCase().includes(val.toLowerCase())),
    initialSelectedOptions: options.filter(({ value }) =>
      selected.includes(value),
    ),
    update: isOpen,
  });

  return (
    <SearchPicker
      hideIcons
      isOpen={isOpen}
      onClose={onClose}
      isDisabled={isDisabled}
      {...componentProps}
    />
  );
};

export default MultiSelectInputSearchPicker;
